/*
    Third panel in Overview showing historically printed models
 */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    changeDateFilter, changeModelNameFilter,
    startFetchingPrintedModelsWithinSpanThenAppendOrOverride,
    updateToggleListOfPrintItems
} from "../actions/getPrintedModels";
import GenericPanel from "../components/generic_panel";
import CurrentStatusSection, {DisplayedStatusByPrinterStatusType} from './current_status_section';
import PrintsItem from '../components/prints-item';
import InfiniteScroll from 'react-infinite-scroller';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {DATE_FILTER} from "../actions/getPrintedModels";

import 'react-datepicker/dist/react-datepicker.css';
import '../css/prints-panel.css';
import {closeLightbox, openLightbox} from "../actions/lightbox";
import Lightbox from "react-image-lightbox";
import LoadingAnimation from "../components/loading-animation";

class PrintedModelsPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // whether filters on this page is toggled on
            startDateFiltered: false,
            endDateFiltered: false,
            startDateInputFocused: false,
            endDateInputFocused: false
        }
    }

    componentDidMount() {
        const promiseOfRefresh = this.refresh(Date.now(), null, false);
        if (!promiseOfRefresh) return;

        promiseOfRefresh.then(this.initToggleListOfPrintRecordItems.bind(this));
    }

    refresh(endTimeStamp, startTimeStamp, willBeAppendedToList) {
        if (!this.props.userProfile || !this.props.userProfile.profile) {
            console.error('Failed to fetch user profile');
            return;
        }
        if (!this.props.hasMore) return;

        try {
            return this.props.startFetchingPrintedModelsWithinSpanThenAppendOrOverride(endTimeStamp, startTimeStamp, willBeAppendedToList);
        } catch (err) {
            console.log(err.message);
        }
    }

    initToggleListOfPrintRecordItems() {
        const allRecordsOfPrints = this.props.printedModels;
        const tempToggleList = [...this.props.togglesOfPrintRecordItems];
        allRecordsOfPrints.map(payload => {
            tempToggleList.push(false);
        })
        this.props.updateToggleListOfPrintItems(tempToggleList);
    }

    render() {
        const { openLightbox, closeLightbox, lightboxSrc, isLightboxOpen } = this.props;

        return (
            <div>
                { isLightboxOpen &&
                    <Lightbox mainSrc={lightboxSrc} onCloseRequest={closeLightbox}/> }

                <GenericPanel title='Current Jobs'>
                    <CurrentStatusSection
                        openLightbox={openLightbox}
                    />
                </GenericPanel>
                {this.filtersOfPrints()}
                <InfiniteScroll
                    pageStart={0}
                    threshold={0}
                    loadMore={this.handleInfiniteLoad.bind(this)}
                    hasMore={this.props.hasMore && !this.props.loading}
                >
                    {this.loadListOfPrints()}
                </InfiniteScroll>
            </div>
        );
    }

    filtersOfPrints() {
        return <div className='filter-container'>
            <form className='model-name-filter'>
                <input
                    placeholder='Search For Print Jobs...'
                    type="text"
                    onChange={(ev) => {
                        const modelNameFilter = ev.target.value;
                        this.props.changeModelNameFilter(modelNameFilter);
                    }}
                    value={this.props.modelNameFilter}
                />
                {this.props.modelNameFilter ?
                    <i className="material-icons search-clear-ctn"
                       onClick={() => {
                           this.props.changeModelNameFilter('');
                       }}
                    >clear</i> : <i className="material-icons search-clear-ctn">search</i>}
            </form>
            <div className='date-filter-container'>
                <form className='date-filter'>
                    <DatePicker
                        onChange={(date) => {
                            console.log(date);
                            if (!date) {
                                this.setState({startDateFiltered: false});
                                this.props.changeDateFilter(moment(0), DATE_FILTER.START);
                            }
                            else {
                                this.setState({startDateFiltered: true});
                                this.props.changeDateFilter(date, DATE_FILTER.START);
                            }
                        }}
                        selected={!this.state.startDateFiltered ? null : moment(this.props.startTimeStamp)}
                        placeholderText={"Start time"}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                    />
                    <i className="material-icons">calendar_today</i>
                </form>
                <form className='date-filter'>
                    <DatePicker
                        onChange={(date) => {
                            console.log(date);
                            if (!date) {
                                this.setState({startDateFiltered: false});
                                this.props.changeDateFilter(moment(new Date()).add(1, 'days').toDate().getTime(), DATE_FILTER.END);
                            }
                            else {
                                this.setState({endDateFiltered: true});
                                this.props.changeDateFilter(date, DATE_FILTER.END);
                            }
                        }}
                        selected={!this.state.endDateFiltered ? null : moment(this.props.endTimeStamp - 1000 * 60 * 60 * 24)}
                        placeholderText={"End time"}
                        minDate={moment(this.props.startTimeStamp)}
                        showYearDropdown
                        scrollableYearDropdown
                        yearDropdownItemNumber={15}
                    />
                    <i className="material-icons">calendar_today</i>
                </form>
            </div>
        </div>
    }

    loadListOfPrints() {
        const listOfPrintedModels = this.props.printedModels;
        const printsListByDate = this.dividePrintsByDate(listOfPrintedModels);

        if (this.props.error) {
            return <div>Failed to load printed models</div>
        }

        return <div>
            {printsListByDate}
            {this.props.loading ? <LoadingAnimation/> : null}
        </div>;
    }

    dividePrintsByDate(listOfPrintRecords) {
        if (!listOfPrintRecords) return [];

        const itemClustersByDates = this.getItemClustersByDates(listOfPrintRecords);
        const recordCardsByDates = itemClustersByDates.map((recordClusterByDate, indexOfCluster) => {
            const dateLiteral = Object.keys(recordClusterByDate)[0];
            return <GenericPanel
                title={this.formattedCardHeaderFromDate(new Date(dateLiteral))}
                key={indexOfCluster}
            >
                {recordClusterByDate[dateLiteral]}
            </GenericPanel>
        })
        return (
            <div>
                {recordCardsByDates}
            </div>
        )
    }

    getItemClustersByDates(listOfPrintRecords) {
        let ItemClustersByDates = [];
        let tempClusterOfPrintsItems = [];
        let printDateOfLastRecord = new Date();

        listOfPrintRecords.forEach((recordOfPrint, index) => {
            const {timeStamp, modelName} = recordOfPrint;
            const printDate = new Date(timeStamp);
            // filtering by date & name filters
            if (this.shouldFilterOut(timeStamp, modelName))
                return;

            if (this.isSameDay(printDate, printDateOfLastRecord)) {
                tempClusterOfPrintsItems.push(this.getPrintsItem(recordOfPrint, index));
            } else {
                this.addTempClusterToItemClusterByDate(tempClusterOfPrintsItems, ItemClustersByDates, printDateOfLastRecord);
                tempClusterOfPrintsItems = [this.getPrintsItem(recordOfPrint, index)];
                printDateOfLastRecord = printDate;
            }
        });
        this.addTempClusterToItemClusterByDate(tempClusterOfPrintsItems, ItemClustersByDates, printDateOfLastRecord);
        return ItemClustersByDates;
    }

    shouldFilterOut(timeStamp, modelName) {
        const dateFilter = timeStamp < this.props.startTimeStamp || timeStamp > this.props.endTimeStamp;
        const nameFilter = modelName ? modelName.toLowerCase().indexOf(this.props.modelNameFilter.toLocaleLowerCase()) === -1 : false;
        return this.props.filtersOn && (dateFilter || nameFilter);
    }

    isSameDay(date1, date2) {
        return date1.getYear() === date2.getYear()
            && date1.getMonth() === date2.getMonth()
            && date1.getDate() === date2.getDate();
    }

    getPrintsItem(recordOfPrint, index) {
        const { openLightbox } = this.props;
        const {compositeScope, jobId} = recordOfPrint;
        const previewFileName = `${compositeScope}@${jobId}.png`;

        return <PrintsItem
            {...recordOfPrint}
            printerName={recordOfPrint.printerName}
            key={index}
            index={index}
            expanded={this.props.togglesOfPrintRecordItems[index]}
            displayedStatus={DisplayedStatusByPrinterStatusType[recordOfPrint.status]}
            previewFileName={previewFileName}
            openLightbox={openLightbox}
        />
    }

    addTempClusterToItemClusterByDate(tempClusterOfPrintsItems, ItemClustersByDates, printDateOfLastRecord) {
        if (tempClusterOfPrintsItems.length === 0) return;

        ItemClustersByDates.push({[printDateOfLastRecord]: tempClusterOfPrintsItems});
    }

    formattedCardHeaderFromDate(date) {
        let dayIndicator = '';
        const today = new Date();
        const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
        if (this.isSameDay(today, date)) {
            dayIndicator = 'Today';
        } else if (this.isSameDay(yesterday, date)) {
            dayIndicator = 'Yesterday';
        } else {
            dayIndicator = moment(date).format("dddd");
        }
        let formattedDate = moment(date).format("LL");
        return `${dayIndicator}, ${formattedDate}`;
    }

    handleInfiniteLoad() {
        const {timeStampOfBottomRecord} = this.props;
        this.refresh(timeStampOfBottomRecord - 1, null, true);
    }
}

const mapStateToProps = state => ({
    ...state.printedModels,
    userProfile: state.userProfile,
    isLightboxOpen: state.lightbox.isLightboxOpen,
    lightboxSrc: state.lightbox.src
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        startFetchingPrintedModelsWithinSpanThenAppendOrOverride,
        updateToggleListOfPrintItems,
        changeDateFilter,
        changeModelNameFilter,
        openLightbox,
        closeLightbox
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrintedModelsPanel);



// WEBPACK FOOTER //
// ./src/containers/prints_panel.js